module.exports = __webpack_public_path__ + "assets/clock.d37d3b21.svg";